import styled from 'styled-components'
import { colors } from '../../config/theme'

export const IconStyled = styled.i`
  font-size: ${(props) => (props.size ? props.size : '12px')};
  color: ${(props) => (props.size ? props.size : colors.common.black)};
`
